export const PRESALE_ADDRESSES: { [key: number]: string } = {
  // 4: "0xfAB8d8dC568Ff4745D56D0489bF17ce1dAc80296",
  // 3: "0xDA1ac58Ed5b94Dc3850f92c2639DA226D4F6b9cE",
  1: "0x93df122cb41c9093db53a418e07a07d45d3d1ace",
  // 97: "0xaD55F12eE2F433aA47B2515486cfBd4F1c8aFDF2",
};
